import { Actions } from 'vuex-smart-module';
import { DataPilotService } from '../../../../services';
import ReasonsCommunicationGetters from './getters';
import ReasonsCommunicationMutations from './mutations';
import { ReasonsCommunicationState } from './state';

const dataPilotService = new DataPilotService();

export default class ReasonsCommunicationActions extends Actions<
  ReasonsCommunicationState,
  ReasonsCommunicationGetters,
  ReasonsCommunicationMutations,
  // eslint-disable-next-line no-use-before-define
  ReasonsCommunicationActions
> {
  async get_reasons_communication() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const payload = {
        filters: this.state.filters,
        filters_exist: false,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING(true);
      const { data, meta } = await dataPilotService.get_reasons_communication(payload);

      this.mutations.SET_CLIENT_EVENTS(data.items);
      this.mutations.SET_EVENTS(data.filters.events);
      this.mutations.SET_ADDRESSES(data.filters.addresses);

      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING(false);
    }
  }

  async update_event(payload: any) {
    try {
      await dataPilotService.update_event(payload);
    } catch (error) {
      console.log(error);
    }
  }

  async viewed(id: number) {
    try {
      const { data } = await dataPilotService.viewed(id);

      this.mutations.UPD_VIEWED_EVENT(data);
    } catch (error) {
      console.log(error);
    }
  }
}
